export const getImageSizes = () => {
    const mobile = '(max-width: 768px) 768w';
    const tablet = '(max-width: 992px) 992w';
    const desktop = '(max-width: 1440px) 1440w';
    const desktopBig = '(min-width: 1441px)';

    return `${mobile}, ${tablet}, ${desktop}, ${desktopBig}`;
};
